import React from "react";
import { ART_STATUSES, DEFAULT_PRICE } from "../lib/artwork";

const inp = "bg-[#0A0A0A] border border-white/10 px-2 py-1.5 font-body text-sm text-white focus:border-[#14A89A] outline-none";

// Builder fields for an Artwork item: details, status, optional price and display quality.
export const ArtworkFields = ({ art, onChange }) => {
  const set = (k, v) => onChange({ ...art, [k]: v });
  return (
    <div className="border border-white/8 bg-[#0A0A0A]/60 p-2.5 space-y-2" data-testid="artwork-fields">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
        <input value={art.year} onChange={(e) => set("year", e.target.value)} placeholder="Year (e.g. 2025)" maxLength={20} data-testid="artwork-year" className={inp} />
        <input value={art.medium} onChange={(e) => set("medium", e.target.value)} placeholder="Medium (e.g. Oil on linen)" maxLength={80} data-testid="artwork-medium" className={inp} />
        <input value={art.size} onChange={(e) => set("size", e.target.value)} placeholder="Size (e.g. 36 x 48 in)" maxLength={60} data-testid="artwork-size" className={inp} />
      </div>
      <div className="flex flex-wrap items-center gap-3">
        <label className="flex items-center gap-2 font-body text-xs text-zinc-400">Status
          <select value={art.status} onChange={(e) => set("status", e.target.value)} data-testid="artwork-status" className={inp}>
            {ART_STATUSES.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
          </select>
        </label>
        {art.status === "sold" && (
          <label className="flex items-center gap-1.5 font-body text-xs text-zinc-400"><input type="checkbox" checked={!!art.sold_mark} onChange={(e) => set("sold_mark", e.target.checked)} data-testid="artwork-sold-mark" className="accent-[#14A89A]" /> Show a "Sold" mark on the image</label>
        )}
      </div>
      <div className="space-y-1.5">
        <label className="flex items-center gap-1.5 font-body text-xs text-zinc-400"><input type="checkbox" checked={!!art.show_price} onChange={(e) => set("show_price", e.target.checked)} data-testid="artwork-show-price" className="accent-[#14A89A]" /> Add a price</label>
        {art.show_price && <input value={art.price} onChange={(e) => set("price", e.target.value)} onBlur={() => !art.price.trim() && set("price", DEFAULT_PRICE)} placeholder={DEFAULT_PRICE} maxLength={60} data-testid="artwork-price" className={`${inp} w-full sm:w-64`} />}
        {art.show_price && <p className="font-body text-[11px] text-zinc-600">Shown as written. Buyers reach you through a private Exchange; you arrange payment yourself.</p>}
      </div>
      <div>
        <span className="font-body text-xs text-zinc-400">Display quality</span>
        <div className="flex gap-2 mt-1">
          {[["standard", "Standard", "fast, smaller files"], ["gallery", "Gallery", "larger and zoomable, uses more storage"]].map(([v, l, d]) => (
            <button key={v} type="button" onClick={() => set("quality", v)} data-testid={`artwork-quality-${v}`}
              className={`text-left border px-3 py-1.5 font-body text-xs transition-colors ${art.quality === v ? "border-[#14A89A] text-white bg-[#14A89A]/10" : "border-white/10 text-zinc-400 hover:border-white/25"}`}>
              {l}<span className="block text-[10px] text-zinc-500">{d}</span>
            </button>
          ))}
        </div>
        <p className="font-body text-[11px] text-zinc-600 mt-1.5">We make a sharp display copy on your device, so even huge files upload quickly. Your original file never leaves your device. Quality applies the next time you upload an image.</p>
      </div>
    </div>
  );
};
